import Route from "../Route";

import { Switch } from "react-router-dom";

import VendaRapida from "../../pages/vendas/pedidos/VendaRapida";
import ListagemVendedores from "../../pages/vendas/vendedores/VendedorListagem";
import { VendedoresCadastro } from "../../pages/vendas/vendedores/VendedorCadastro";
import Intermediador from "../../pages/vendas/intermediador/IntermediadorListagem";
import IntermediadoresCadastro from "../../pages/vendas/intermediador/IntermediadorCadastro";

export default function Vendas() {
  return (
    <>
      <Switch>
        <Route
          path="/vendas/vendedores/listagem"
          component={ListagemVendedores}
        />
        <Route
          path="/vendas/vendedores/cadastro"
          component={VendedoresCadastro}
        />
        <Route path="/vendas/pedidos/vendarapida" component={VendaRapida} />
        <Route
          path="/vendas/intermediador/listagem"
          component={Intermediador}
        />
        <Route
          path="/vendas/intermediador/cadastro"
          component={IntermediadoresCadastro}
        />
      </Switch>
    </>
  );
}
